import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { DesignChannel } from 'components/NewFileModal/Types'
import { ReactElement } from 'react'
import { Google, MetaBrand, Shopify, TikTokBrand, TwitterBrand } from 'blaze-ui/icons'
import { InstagramBrand } from 'blaze-ui/icons/24'
import MailchimpBrand from 'blaze-ui/icons/35/MailchimpBrand'
import { WordPressBrand } from 'blaze-ui/icons/35'

export const PlatformIcon = ({
  platform,
  size,
  isSelected,
  isBrand,
}: {
  platform: ExternalIntegrationEnum
  size?: number
  isSelected?: boolean
  isBrand?: boolean
}): ReactElement | null => {
  switch (platform) {
    case ExternalIntegrationEnum.LinkedIn:
      return <ChannelIcon channel={ChannelType.LinkedInPosts} size={size} isWhite={isSelected} />
    case ExternalIntegrationEnum.Instagram:
      if (isBrand) return <InstagramBrand size={size} />

      return <ChannelIcon channel={ChannelType.InstagramPosts} size={size} isWhite={isSelected} />
    case ExternalIntegrationEnum.X:
      if (isBrand) return <TwitterBrand size={size} />

      return <ChannelIcon channel={ChannelType.Tweets} size={size} isWhite={isSelected} />
    case ExternalIntegrationEnum.Facebook:
      return <ChannelIcon channel={ChannelType.FacebookPost} size={size} isWhite={isSelected} />
    case ExternalIntegrationEnum.WordPress:
      return <WordPressBrand size={size} />
    case ExternalIntegrationEnum.Shopify:
      return <Shopify size={size} />
    case ExternalIntegrationEnum.TikTok:
      if (isBrand) return <TikTokBrand size={size} />

      return <ChannelIcon channel={DesignChannel.TikTokPost} size={size} />
    case ExternalIntegrationEnum.Google:
      return <Google size={size} />
    case ExternalIntegrationEnum.YouTube:
      return <ChannelIcon channel={DesignChannel.YoutubeShort} size={size} />
    case ExternalIntegrationEnum.Mailchimp:
      return <MailchimpBrand size={size} />
    case ExternalIntegrationEnum.MetaAds:
      return <MetaBrand size={size} />
    default:
      return null
  }
}
